import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const SubmitAdvanceAccountApplication = gql`
  mutation SubmitAdvanceApplication(
    $idempotencyId: IdempotencyToken!
    $input: SubmitAdvanceAccountApplicationInput!
  ) {
    submitAdvanceAccountApplication(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on SubmitAdvanceAccountApplicationSuccess {
        __typename
        applicationId
      }
      ... on SubmitAdvanceAccountApplicationValidationError {
        __typename
        ...error
      }
      ... on SubmitAdvanceAccountApplicationMissingAgreement {
        __typename
        ...error
      }
      ... on SubmitAdvanceAccountApplicationError {
        ...error
      }
      ... on Error {
        ...error
      }
    }
  }
  ${error}
`;
